import api from '../api/axios';

const BASE = process.env.REACT_APP_BASE_API_URL || process.env.REACT_APP_API_URL || '';
const withBase = (p: string) => `${BASE}${p}`;

export const enqueueByRunId = async (runId: string) => {
  const res = await api.post(withBase(`/video-render/enqueue/${runId}`), {});
  return res.data as { accepted: boolean; reason?: string; job?: any };
};

const videoRenderService = { enqueueByRunId };
export default videoRenderService;
